import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {MenuService} from "./services/menu.service";
import {Menu} from "./model/Menu";
import {TypeService} from "./services/type.service";
import {Type} from "./model/Type";
import {forEach} from "@angular/router/src/utils/collection";
import {PhotoService} from "./services/photo.service";
import {Photo} from "./model/Photo";
import {environment} from "../environments/environment";
import {ToastyConfig, ToastyService} from "ng2-toasty";
import {AuthenticationService} from "./services/authentication.service";

@Component({
    selector: 'app-admin-manage-types',
    templateUrl: './manage-menus.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [MenuService, TypeService, PhotoService]
})

export class ManageMenusComponent implements OnInit {
    ngOnInit(): void {
        //this.getOrder();
        this.getListMenus();
        this.getListTypes();
    }
    title = 'My Order App';

    constructor(private menuService : MenuService,
                private typeService : TypeService,
                private photoService : PhotoService,
                private toastyService:ToastyService,
                private toastyConfig: ToastyConfig,
                private router: Router,
                private authenticateService: AuthenticationService) {
        this.toastyConfig.theme = 'bootstrap'
    }
    order = null;
    listMenus: Menu[];
    listTypes: Type[];
    //active = false;
    active: any[][] = [];
    editable: boolean[] = [];
    activeTypes: boolean[] = [];
    photoIsModifiable: boolean[] = [];
    imageBaseUri: string = environment.imageBaseUri;
    instantPaiementApi: string = environment.instantPaiementApi;

    getToken() {
        return this.authenticateService.getToken();
    }

    getListMenus(): void {

        this.menuService.getListMenus().then((listMenus) => {
            //console.error("taille dans le app.component = " + listMenus[0].id);
            this.listMenus = listMenus;

        }, (error) => {
            console.error(error);
        });

    }

    getListTypes(): void {
        this.typeService.getListTypes().then((listTypes) => {
            this.listTypes = listTypes;
            for(let curType of this.listTypes) {
                this.activeTypes[curType.id] = false;
            }
        }, (error) => {
            console.error(error);
        });
    }

    modifyMenu(menu: Menu) : void {
        this.editable[menu.id] = true;
        for(let curType of menu.typesList) {
            this.activeTypes[curType.id] = true;
        }
    }

    cancelEdit(menu: Menu) : void {
        this.editable[menu.id] = false;
        if(menu.id == null) {
            let index = this.listMenus.indexOf(menu);
            this.listMenus.splice(index, 1);
        }
    }

    saveMenu(menu: Menu, posMenu: number) : void {
        let newListTypes: Type[] = [];
        for(let curType of this.listTypes) {
            if(this.activeTypes[curType.id] == true) {
                newListTypes.push(curType);
            }
        }
        menu.typesList = newListTypes;

        if(menu.id == null) {
            this.menuService.addMenu(menu).then((result) => {
                this.editable[menu.id] = false;
            }, (error) => {
                console.error(error);
            });
        } else {
            this.menuService.modifyMenu(menu).then((result) => {
                this.editable[menu.id] = false;
            }, (error) => {
                console.error(error);
            });
        }

    }

    modifyImage(isModifiable: boolean, idMenu: number): void {
        this.photoIsModifiable[idMenu] = isModifiable;
    }

    imageUploaded(event, menu:Menu) {
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let result = response.result;
        let idPhoto = response.id;
        let urlPhoto = response.url;
        if(result) {
            menu.photo.id = idPhoto;
            menu.photo.url = urlPhoto;
        } else {
            this._addToast("error", response.error.message);
        }
    }

    imageRemoved(event, menu:Menu) {
        //console.log("imageRemoved : " + JSON.stringify(event));
        let serverResponse = event.serverResponse;
        let response = JSON.parse(serverResponse._body);

        let idPhotoToDelete = response.id;

        if(idPhotoToDelete != null) {
            this.photoService.removePhoto(idPhotoToDelete).then((listProducts) => {
                //console.error("taille dans le app.component = " + listProducts);

            }, (error) => {
                console.error(error);
            });
        }

    }

    createMenu() : void {
        let newMenu = new Menu();
        newMenu.photo = new Photo();
        newMenu.typesList = [];

        this.listMenus.push(newMenu);
        this.editable[newMenu.id] = true;
    }

    private _addToast(type: string, message: string) {
        // Just add default Toast with title only
        if(type === "error") {
            this.toastyService.error(message);
        } else {
            this.toastyService.default(message);
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/manage-menus.component.ts